import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { HTTPService } from 'src/app/services/http.service';
import * as fileSaver from 'file-saver';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { LanguageServices } from 'src/app/services/LanguageServices';
import { DatePipe } from '@angular/common';
import { tap } from 'rxjs/operators';

export interface file{
   filename:string,
   size:number,
   lastchange:string
}

@Component({
    selector: 'log-aplicacao',
    templateUrl: './log-aplicacao.component.html',
    styleUrls: ['./log-aplicacao.component.scss'],
    standalone: false
})


export class LogAplicacaoComponent implements OnInit {

  time = 1;
  atualizacao:String;
  interval: NodeJS.Timeout;

  constructor(private http:HTTPService, private snackBar:SnackbarService,public datepipe: DatePipe,
    private cd:ChangeDetectorRef, private ls:LanguageServices) {

      this.startInterval();

  }

  listOfFiles:Observable<file[]> = new Observable();
  selectedFiles:file[] = [];

  mensagens:Object[] = [];

  ngOnInit(): void {
      this.loadFiles();
  }

  ngOnDestroy(){
    clearInterval(this.interval);
  }

  private startInterval(){
    clearInterval(this.interval);
    const minutes = this.time > 0 ? this.time : 1;
    this.interval = setInterval(()=>{
        this.refresh();
        this.cd.markForCheck();
    }, minutes*1000*60);
  }

  // reinicia o timer quando o usuario altera o tempo de atualizacao
  // (antes o valor digitado nao tinha efeito no intervalo ja criado)
  onTimeChange(value:number){
    this.time = value;
    this.startInterval();
  }

  isSelected(file:file):boolean{
    return this.selectedFiles.indexOf(file) > -1;
  }

  toggleFile(file:file, checked:boolean){
    if ( checked ){
      if ( this.selectedFiles.indexOf(file) === -1 ){
        this.selectedFiles.push(file);
      }
    }else{
      const index = this.selectedFiles.indexOf(file);
      if ( index > -1 ){
        this.selectedFiles.splice(index,1);
      }
    }
  }

  loadFiles(){
      this.selectedFiles = []; // instancias antigas nao existem mais apos recarregar
      this.listOfFiles = this.http.postGeneric<file[]>({}, "ExceptionServices/getFilesError",false,true);
      this.atualizacao = this.datepipe.transform(new Date(), 'dd/MM/yyyy HH:mm:ss');
      this.listOfFiles = this.listOfFiles.pipe(tap(x=>{
        if ( x!= null ){
          x.sort((a:file,b:file)=>{

            if (a.size > b.size  ) return -1;
            if (a.size < b.size  ) return 1;
            return 0;
          });
        }

      }))
  }

  download(){

    this.selectedFiles.forEach(file=>{
      this.downloadFile(file.filename);
    })


  }

  downloadFile(filename: string) {

    this.http.downloadFile(`ExceptionServices/${filename}/text`).subscribe(data=>{
      const blob = data;
      fileSaver.saveAs(blob, filename);

    });
  }

  viewFile(){

    if ( this.selectedFiles.length > 1 ){
      this.snackBar.showError(this.ls.instant('logaplicacao.selectOne'));
      return;
    }

    if ( this.selectedFiles.length == 0 ){
      return;
    }

    let file = this.selectedFiles[0];
    let thread = file.filename.match('(?<=_)[^\._\r\n]*(?=\.)')[0]

    let ob = {
        thread: thread
    }

    this.http.post(ob,'ExceptionServices/getError',false,true).subscribe(data=>{
          this.mensagens = [...data as Object[]];
    })
  }


  refresh(){
    this.loadFiles();
  }
}
